"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _reactRedux = require("react-redux");

var _radiusSelect = _interopRequireDefault(require("../../_common/radiusSelect"));

var _medicationSelect = _interopRequireDefault(require("../../_common/medicationSelect"));

var _specialtySelect = _interopRequireDefault(require("../../_common/specialtySelect"));

var _locations = require("../../../redux/locations");

var _actions = require("../../../redux/attributes/actions");

var _actions2 = require("../../../redux/locations/actions");

var _selectors = require("../../../redux/locations/selectors");

var _icCheckOn = _interopRequireDefault(require("../../../img/ic-check-on.svg"));

var _icCheckOff = _interopRequireDefault(require("../../../img/ic-check-off.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Filters = function Filters() {
  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      filter = _useSearchSelector.filter;

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.loadAttributes)());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-filters-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-form-clear-filters"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "text",
    onClick: function onClick() {
      return dispatch((0, _actions2.clearFilters)());
    }
  }, "Clear Filters")), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_radiusSelect.default, {
    className: "bodyFont",
    disableUnderline: false,
    onChange: function onChange() {},
    fullWidth: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-filters-checkboxes flex flexWrap"
  }, _locations.checkBoxFilters.map(function (checkboxFilter) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "filter-".concat(checkboxFilter.key),
      className: "locator-form-checkbox-filter flex align-items-center"
    }, /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
      control: /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        icon: /*#__PURE__*/_react.default.createElement("img", {
          src: _icCheckOff.default,
          alt: "unchecked icon"
        }),
        checkedIcon: /*#__PURE__*/_react.default.createElement("img", {
          src: _icCheckOn.default,
          alt: "checked icon"
        }),
        checked: filter[checkboxFilter.key],
        onChange: function onChange(event) {
          dispatch((0, _actions2.updateFilter)(checkboxFilter.key, event.target.checked));
        },
        value: "checkedB",
        color: "primary"
      }),
      label: checkboxFilter.label
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-filters-select-containers"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop15"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom20"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "locator-form-filters-label"
  }, "Medications Available:")), /*#__PURE__*/_react.default.createElement(_medicationSelect.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginBottom15"
  }, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      fontSize: "15px",
      fontFamily: "Lato",
      color: "#979a9f",
      lineHeight: "normal",
      fontWeight: "200"
    }
  }, "Specialty:")), /*#__PURE__*/_react.default.createElement(_specialtySelect.default, null)))), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement("hr", {
    className: "big-divider"
  })));
};

var _default = Filters;
exports.default = _default;